import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import ProtectedRoute from '../protected-route'

const HomePage = lazy(() => import('../../../../pages/business/home'))
const ProductsPage = lazy(() => import('../../../../pages/business/products'))
const BusinessPage = lazy(() => import('../../../../pages/business/business'))
const ProductPage = lazy(() => import('../../../../pages/business/product'))
const ReportPage = lazy(() => import('../../../../pages/business/reports'))
const OrdersPage = lazy(() => import('../../../../pages/business/orders'))
const AdsPage = lazy(() => import('../../../../pages/ads'))
const PaymentsPage = lazy(() => import('../../../../pages/business/payments'))
const SchedulesPage = lazy(() => import('../../../../pages/business/schedules'))
const PromoPage = lazy(() => import('../../../../pages/business/promo'))
const UploadProductsPage = lazy(() =>
	import('../../../../pages/business/upload-products')
)
const UploadAdditionsPage = lazy(() =>
	import('../../../../pages/business/upload-additions')
)

const companyRoutes = (business, type) => (
	<>
		<Route
			path='/payments'
			element={
				<ProtectedRoute>
					<PaymentsPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/ads'
			element={
				<ProtectedRoute>
					<AdsPage type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/orders'
			element={
				<ProtectedRoute>
					<OrdersPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/schedules'
			element={
				<ProtectedRoute>
					<SchedulesPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/product/:id'
			element={
				<ProtectedRoute>
					<ProductPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/promo/:id'
			element={
				<ProtectedRoute>
					<PromoPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/reports'
			element={
				<ProtectedRoute>
					<ReportPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/information'
			element={
				<ProtectedRoute>
					<BusinessPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/products/list'
			element={
				<ProtectedRoute>
					<UploadProductsPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/products/additions/list'
			element={
				<ProtectedRoute>
					<UploadAdditionsPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/products'
			element={
				<ProtectedRoute>
					<ProductsPage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
		<Route
			path='/home'
			element={
				<ProtectedRoute>
					<HomePage business={business.data} type={type} />
				</ProtectedRoute>
			}
		/>
	</>
)

export default companyRoutes
